import React from 'react'
import './style.scss'
import ImgLogoWhite from '../../assets/images/logo.svg'
import ImgLogoPurple from '../../assets/images/logo-purple-and-black.svg'

export const BaseLayout = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="base-layout-container">
      <div className="left-container">
        <img src={ImgLogoWhite} alt="logo" className="logo" />
      </div>
      <div className="right-container">
        <div className="children-container">
          <img src={ImgLogoPurple} alt="logo" className="logo" />

          {children}
        </div>
      </div>
    </div>
  )
}
